import getNodeUrl from "@/hooks/getRpcUrl";
import { CHAIN_PROVIDER_POLLING_INTERVAL } from "@/utils/constant";
import { providers, Contract } from "ethers";

export const formatBalance = (balance: any): string => {
	const num = typeof balance === "string" ? parseFloat(balance) : balance;
	if (isNaN(num)) return "0.00";
	return num.toLocaleString(undefined, {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	});
};

export const formatInputNumber = (val: string): string => {
	if (!val) return "";
	const [int, dec] = val.replace(/,/g, "").split(".");
	const intFormatted = int.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	return dec !== undefined ? `${intFormatted}.${dec}` : intFormatted;
};

let readProvider: providers.StaticJsonRpcProvider | providers.JsonRpcProvider | undefined;
const cachedDecimals: { [address: string]: number } = {};

export function getProvider(forWrite = false) {
	if (forWrite && typeof window !== "undefined" && window.ethereum) {
		return new providers.Web3Provider(window.ethereum);
	}
	if (readProvider) return readProvider;
	const rpcUrl = getNodeUrl()
	if (rpcUrl) {
		// Use StaticJsonRpcProvider to minimize network calls for static reads
		readProvider = new providers.JsonRpcProvider(rpcUrl);
		// Reduce default polling frequency
		readProvider.pollingInterval = CHAIN_PROVIDER_POLLING_INTERVAL;
		return readProvider;
	}
	if (typeof window !== "undefined" && window.ethereum) {
		readProvider = new providers.Web3Provider(window.ethereum);
		return readProvider;
	}
	return undefined;
}

export async function getDecimals(address: string, provider?: providers.Provider): Promise<number> {
    if (!address) return 18;
    const key = address.toLowerCase();
    if (cachedDecimals[key] !== undefined) return cachedDecimals[key];
    provider = provider || getProvider();
    if (!provider) throw new Error("No provider available");
    const contract = new Contract(address, ["function decimals() public view returns (uint8)"], provider);
    const dec = await contract.decimals();
    const value = typeof dec === "number" ? dec : Number(dec);
    cachedDecimals[key] = value;
    return value;
}

export function getExplorerTxUrl(txHash: any): string {
	const chainId =
		import.meta.env.VITE_CHAIN_ID || window.ethereum?.networkVersion;
	if (!txHash) return "#";
	switch (chainId) {
		case "1":
			return `https://etherscan.io/tx/${txHash}`;
		case "5":
			return `https://goerli.etherscan.io/tx/${txHash}`;
		case "56":
			return `https://bscscan.com/tx/${txHash}`;
		case "97":
			return `https://testnet.bscscan.com/tx/${txHash}`;
		default:
			return `https://etherscan.io/tx/${txHash}`;
	}
}

export function shortenHash(hash: any, len = 6): string {
	if (!hash) return "";
	return hash.slice(0, len) + "..." + hash.slice(-len);
}

export async function waitForEthereum(timeout = 2000) {
	const interval = 100;
	let waited = 0;
	while (
		typeof window !== "undefined" &&
		!window.ethereum &&
		waited < timeout
	) {
		await new Promise((res) => setTimeout(res, interval));
		waited += interval;
	}
	return window.ethereum;
}

export async function getUserProvider() {
	const eth = await waitForEthereum();
	if (!eth)
		throw new Error(
			"Vui lòng mở website này bằng trình duyệt Dapp của Metamask!"
		);
	const provider = new providers.Web3Provider(eth, "any");
	try {
		await provider.send("eth_requestAccounts", []);
	} catch (err) {
		throw new Error("Bạn cần kết nối ví để thực hiện thao tác này!");
	}
	return provider;
}
